module.exports = __webpack_public_path__ + "img/r-rachel-park-366508-unsplash-min-800x527.0f0fb6e3.jpg";